import { AuthenticatedLayout } from "../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { DefaultSettings } from "../../components/DefaultSettings";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const DefaultSettingsPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Default Settings"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Default Settings', navigateTo: '/me/default-settings'}]}
      mainContents={<DefaultSettings testId="default-settings-setup-page" />}
    />
  );
};
